/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';

function CustomToast({
    open, message, setopen, color,
}) {
    return (

        <Modal open={open} onClose={() => setopen(false)} showCloseIcon={false} styles={{ modal: { zIndex: 99999 } }}>
            <div data-testid="toast-message" className="z-[9999] inline-flex items-center alert alert-dismissible shadow-s2 fade w-[410px] absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 admin-login-otp" role="alert" data-bs-dismiss="alert" aria-label="Close">
                <div className={`flex items-center  pl-2 border-l-8 border-[${color || '#309A5D'}] bg-[#FFFFFF] rounded-[7px] h-[60px] cursor-pointer`}>
                    {message}
                </div>
            </div>
        </Modal>

    );
}

export default CustomToast;
